import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { BIRIYANI_BAZAAR } from "../../../constants/Constants";
require("./booth.scss");

class InteractiveMap extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Biriyani Bazaar</div>
        <Card.Img className="booth-image" src="/mutton-biryani.png" />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {BIRIYANI_BAZAAR.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default InteractiveMap;
